import { ListingType, ModalName, PaymentGatewayType } from '@share/enums';
import { PaymentGateway } from '@share/interfaces';
import { listing } from '@state/private';
import { toggleBootstrapModal } from '@util/helper';
import { useSystemConfig } from 'src/hooks';
import { useTranslation } from 'react-i18next';
import { user } from '@state/user';
import SkeletonImage from '@com/utils/SkeletonImage';
import styled from '@emotion/styled';

interface Props {
  listingType: ListingType;
}

const GatewayButton = styled.div`
  transition: all 0.4s ease;
  :hover {
    transform: scale(1.03);
  }
`;

function PaymentMethodModal({ listingType }: Props): JSX.Element {
  /* Define state / hook */
  const { t } = useTranslation();
  const { config } = useSystemConfig();
  const { isNoMetamask } = user.useContainer();
  const { setPaymentMethods } = listing.useContainer();

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */
  const handleClick = (gateway: PaymentGateway) => {
    setPaymentMethods(gateway.methods);
    toggleBootstrapModal(
      ModalName.SELECT_PAYMENT,
      listingType === ListingType.BID
        ? ModalName.CREATE_BID
        : ModalName.CREATE_BUY
    );
  };

  const noCryptoForEmailAccount = (gateway: PaymentGateway) => {
    return (
      (isNoMetamask &&
        gateway.payment_gateway_type !== PaymentGatewayType.CRYPTOCURRENCY) ||
      !isNoMetamask
    );
  };

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <div
      aria-hidden
      className="modal fade popup"
      id={ModalName.SELECT_PAYMENT}
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered mt-0 mb-0"
        role="document"
      >
        <div className="modal-content">
          <button
            className="close"
            type="button"
            onClick={() => {
              toggleBootstrapModal(ModalName.SELECT_PAYMENT);
            }}
          >
            <span aria-hidden>&times;</span>
          </button>

          <div className="modal-body space-y-20 pd-40">
            <h3>{t('modal.choosePaymentMethod')}</h3>
            <hr />
            {config?.payment_gateways
              ?.filter(noCryptoForEmailAccount)
              ?.map((gateway, index) => (
                <GatewayButton
                  key={index}
                  className="mb-5"
                  role="button"
                  onClick={() => handleClick(gateway)}
                >
                  <SkeletonImage
                    alt={gateway.payment_gateway}
                    ratio={3}
                    src={gateway.payment_gateway_logo}
                  />
                </GatewayButton>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentMethodModal;
